exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav_cha {\n    padding-left: 10px;\n    border-left: 5px solid #1ab394;\n    height: 16px;\n    line-height: 16px;\n    margin: 12px;\n    font-weight: bold;\n    text-align: left;\n}\n.red {\n    color: red;\n    position: relative;\n    left: 30px;\n    top: 10px\n}\n.red1 {\n    color: red;\n    position: relative;\n    left: 15px;\n    top: 10px\n}\n.red2 {\n    color: red;\n    position: relative;\n    top: 10px\n}\n.float {\n    position: absolute;\n    bottom: 0px;\n    right: -45px;\n}\n.evaluate {\n    width: 80%;\n    margin-left: 27px;\n}\n.evaluate .el-form-item__content{\n    width: 100%;\n}\n.hold {\n    margin: auto;\n    width: 200px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0921eec1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/physical/teacherPhyEdit.vue
// module id = attr
// module chunks = 3